module.exports = __webpack_public_path__ + "static/media/Photo12.72c79c57.jpg";